/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Model from '@tripian/model';
import CloseIconButton from '../base/Button/Icons/CloseIconButton/CloseIconButton';
import { Link } from '../base/Svg/Icons';
import Button from '../base/Button/Button';
import classes from './SharePoiModal.scss';

interface IShareTripModal {
  poiName?: string;
  poiId: string;
  onCancel: () => void;
  t: (value: Model.TranslationKey) => string;
}

const ShareTripModal: React.FC<IShareTripModal> = ({ poiName, poiId, onCancel, t }) => {
  const [copySuccess, setCopySuccess] = useState('');

  const poiUrl = `${window.location.origin}/place/${poiId}`;

  const copyToClipBoard = async (copyMe: string) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess('Copied!');
      setTimeout(() => {
        setCopySuccess('');
      }, 1000);
    } catch (err) {
      setCopySuccess('Failed!');
    }
  };

  return (
    <div className={classes.shareModal}>
      <div className={classes.dialog}>
        <div className={classes.header}>
          <CloseIconButton className="w-6 h-6" fill="#2B2B33" clicked={onCancel} />
        </div>

        <div>
          <div className={classes.title}>{poiName}</div>
          <hr className={classes.divider} />

          <div>
            <div className={classes.linkContainer}>
              <div className={classes.linkText}>
                <Link size="1rem" className={classes.linkIcon} />
                <span>{poiUrl}</span>
              </div>
              <Button color="primary" className={classes.copyButton} onClick={() => copyToClipBoard(poiUrl)} text={copySuccess ? `${t('trips.shareTrip.copiedLink')}` : `${t('trips.shareTrip.copyLink')}`} />
            </div>
            <div className={classes.footer}>
              <div className={classes.asterisk}>*</div>
              <div>Anyone with this link can view this poi</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareTripModal;
